module.exports = __webpack_public_path__ + "img/signr-verified-transparent.9de418d3.png";